import { Link } from 'react-router'
import TrueTenentLogo from '/img/TrueTenant-heading.png'

export function AuthHeader() {
	return (
		<div className="bg-[#000] md:bg-[#fff] block md:hidden">
			<div className="flex items-center bg-[#fff] justify-center mb-[30px] p-[0px_20px] md:p-0">
				<Link to="/">
					<img
						src={TrueTenentLogo}
						className="w-[150px]"
						alt="TrueTenant Logo"
					/>
				</Link>
			</div>
		</div>
	)
}
